import type {
  SdkApiHandle,
  SdkNotificationListOptions,
  SdkNotificationTemplateList,
  SdkNotificationTypeList,
  SdkNotificationTypeListOptions
} from '@Pages/pageRuntime/sdk/types';

import { useApi } from './useApi';

export function useNotificationTypes(
  options: SdkNotificationTypeListOptions = {}
): SdkApiHandle<SdkNotificationTypeList> {
  const params = {
    page: options.page ?? 1,
    per_page: options.perPage ?? 50,
    filter: {
      search: options.search?.trim() || undefined,
      recipient_mode: options.recipientMode,
      delivery_channel: options.deliveryChannel
    }
  };
  return useApi(
    ['notification-types', params],
    (api) => api.get<SdkNotificationTypeList>('/api/email-messages/notification-types', { params }),
    { enabled: options.enabled }
  );
}

export function useNotificationTemplates(
  notificationTypeId: string | null | undefined,
  options: SdkNotificationListOptions = {}
): SdkApiHandle<SdkNotificationTemplateList> {
  const params = {
    page: options.page ?? 1,
    per_page: options.perPage ?? 50,
    filter: {
      notification_type_id: notificationTypeId,
      search: options.search?.trim() || undefined,
      delivery_channel: options.deliveryChannel
    }
  };
  return useApi(
    ['notification-templates', params],
    (api) =>
      api.get<SdkNotificationTemplateList>('/api/email-messages/notification-templates', {
        params
      }),
    { enabled: (options.enabled ?? true) && !!notificationTypeId }
  );
}
